export default {"src":"/_next/static/media/interest-rate.e251d091.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};